import Chat from "@components/messaging/Chat";
import { InboxContext } from "@components/messaging/InboxProvider";
import styles from "@components/messaging/Messages.module.css";
import MessagesControls from "@components/messaging/MessagesControls";
import Modal from "@components/Modal";
import useContextSafely from "@hooks/useContextSafely";
import useWindowSize from "@hooks/useWindowSize";
import { modalSlideInAnimation, modalSlideOutAnimation } from "@utils/animationUtils";

const Messages = () => {
  const { expandedOpener, opener, selectedChat } = useContextSafely(InboxContext);

  const { screenWidth } = useWindowSize();

  const renderContent = () => (
    <div className={`${styles.messagesFab} ${opener.isOpen ? styles.fabAbsoluteOpen : ""}`} data-test="message-fab">
      {opener.isOpen && (
        <div className={expandedOpener.isOpen ? styles.messagesExpandedFabOpen : styles.messagesFabOpen}>
          {selectedChat ? <Chat chat={selectedChat} /> : <MessagesControls />}
        </div>
      )}
    </div>
  );

  return screenWidth === "lg" || screenWidth === "xl" ? (
    renderContent()
  ) : (
    <Modal
      breakpoints={undefined}
      className="ion-hide-lg-up"
      enterAnimation={modalSlideInAnimation}
      fullHeight
      fullscreen
      handleBehavior={undefined}
      hideHeader
      initialBreakpoint={undefined}
      leaveAnimation={modalSlideOutAnimation}
      opener={opener}
      showBackdrop={false}
    >
      {() => renderContent()}
    </Modal>
  );
};

export default Messages;
